import Vue from 'vue'
import axios from 'axios'
Vue.use(axios)
export default {

  getUserTransactionList ({commit}, data) {
    return new Promise ((resolve, reject) => {
      axios.post('web/get-all-transactions', data)
      .then(response => {
        commit('setPaymentList', response.data)
        console.log(response.data);
      })
    })
  },


}
